import React from 'react';
import { Grid, TextField, Box, Typography, FormControlLabel, Switch } from '@material-ui/core';
import { AccessTime } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

function TimeThresholdForm({
  automation,
  onAutomationChange,
  error,
  classes
}) {
  const { t } = useTranslation();

  const handleToggle = (e) => {
    const isChecked = e.target.checked;
    onAutomationChange({
      ...automation,
      timeThreshold: isChecked,
      lowTimeThreshold: isChecked ? automation.lowTimeThreshold : null,
      highTimeThreshold: isChecked ? automation.highTimeThreshold : null,
    });
  };

  const handleThresholdChange = (field) => (e) => {
    const value = e.target.value;
    onAutomationChange({
      ...automation,
      [field]: value === '' ? null : Number(value),
    });
  };

  return (
    <>
      <FormControlLabel
        classes={{
          root: classes.switchContainer,
          label: classes.switchLabel,
        }}
        labelPlacement="start"
        control={
          <Switch
            checked={automation.timeThreshold}
            onChange={handleToggle}
            name="timeThreshold"
          />
        }
        label={t('processTypes.modal_automation.timeThreshold')}
      />

      {automation.timeThreshold && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              type='number'
              value={automation.lowTimeThreshold || ''}
              onChange={handleThresholdChange('lowTimeThreshold')}
              fullWidth
              label={t('processTypes.timeThreshold_form.labels.low_time_threshold')}
              error={!!error}
              inputProps={{ min: 0 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              type='number'
              value={automation.highTimeThreshold || ''}
              onChange={handleThresholdChange('highTimeThreshold')}
              fullWidth
              label={t('processTypes.timeThreshold_form.labels.high_time_threshold')}
              error={!!error}
              inputProps={{ min: 0 }}
            />
          </Grid>

          <Grid item xs={12}>
            {error && (
              <Typography color="error" variant="caption" display="block">
                {error}
              </Typography>
            )}

            <Box className={classes.previewContainer}>
              <Box className={classes.previewHeader}>
                <Box className={classes.previewIconContainer}>
                  <AccessTime className={classes.previewIcon} />
                  <Typography variant="caption" className={classes.previewTitle}>
                    {t('processTypes.timeThreshold_form.textPreview')}
                  </Typography>
                </Box>
                <Box className={classes.previewChipsContainer}>
                  <Box className={`${classes.previewChip} ${classes.previewChipGreen}`}>
                    <Typography variant="caption">
                      {automation.lowTimeThreshold > 0 && `-${automation.lowTimeThreshold} min`}
                    </Typography>
                  </Box>
                  <Box className={`${classes.previewChip} ${classes.previewChipYellow}`}>
                    <Typography variant="caption">
                      {automation.lowTimeThreshold > 0 && automation.highTimeThreshold > 0 &&
                        `${automation.lowTimeThreshold}-${automation.highTimeThreshold} min`}
                    </Typography>
                  </Box>
                  <Box className={`${classes.previewChip} ${classes.previewChipRed}`}>
                    <Typography variant="caption">
                      {automation.highTimeThreshold > 0 && `+${automation.highTimeThreshold} min`}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Typography variant="caption" color="textSecondary">
              {t('processTypes.timeThreshold_form.helpText')}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default TimeThresholdForm;
